import Authentication from "@/pcm/plugins/authentication/Authentication";

const authentication = new Authentication();
const useAuthentication = () => {
    return authentication;
}

export default {
    install: (app: any) => {
        app.config.globalProperties.$authentication = authentication;
    }
}

export {
    useAuthentication,
}
